/* import __COLOCATED_TEMPLATE__ from './line-pricing.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    price: number;
    flag: string;
    phoneNumber: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const LinePricing = templateOnlyComponent<Signature>();
export default LinePricing;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Deploy::Voice::Provisioning::LinePricing': typeof LinePricing;
  }
}
